module.exports = __webpack_public_path__ + "img/frame (86).877b1f5c.jpg";